'use strict'

import React from 'react'

const Title = () => {
  return (
    <div className='overflow-hidden px-2 flex justify-center mb-4'>
      <div className='w-full'>
        <div className='flex items-center flex-shrink-0 text-black'>
          <div className='mt-3'>
            <h1 className='bold text-4xl md:text-5xl lg:text-6xl'>
              Meeting <span className='text-blue-400'>Costs</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Title
